import AccessCodeGate from '../components/AccessCodeGate';

function AccessAudiobook() {
  return (
    <AccessCodeGate
      type="AUDIOBOOK"
      title="AUDIOBOOK"
      imageSrc="/images/new_images/10.png"
      buttonLabel="ACCESS AUDIOBOOK"
    />
  );
}

export default AccessAudiobook;
